import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import PurchaseOrderRequestLink from '@/components/PurchaseOrderRequestLink'
import CheckoutButton from '@/components/UniversalLoginModal/CheckoutButton'
import { actions as flashActions } from '@/reducers/flashMessages'
import {
  canContinueCheckoutSelector,
  checkoutButtonTextSelector,
  hasBulkPurchaseOrderRequestSelector,
  hasEmptyCartSelector
} from '@/selectors'
import { routeFor } from '@/utils/router'

import TermsCheckbox from './TermsCheckbox'

const BUTTON_CLASSES = 'vst-btn--large-full-width vst-btn--orange'

const BeginCheckoutButton = ({ isDisplayContinueShoppingLink }) => {
  const hasEmptyCart = useSelector(hasEmptyCartSelector)
  const hasBulkPurchaseOrderRequest = useSelector(
    hasBulkPurchaseOrderRequestSelector
  )
  const canContinueCheckout = useSelector(canContinueCheckoutSelector)
  const isNotLoggedIn = useSelector(
    state => !state.mobileMenu.isLoggedIn
  )
  const buttonText = useSelector(checkoutButtonTextSelector)
  const dispatch = useDispatch()
  const intl = useIntl()

  const handleClick = () => {
    if (canContinueCheckout) {
      window.location.assign(routeFor('checkout'))
    } else {
      handleError()
    }
  }

  const handleError = () => {
    dispatch(
      flashActions.setFlashMessages([{
        text: intl.formatMessage({ id: 'errors.accept_terms_failure' }),
        type: 'page_level_message_as_error'
      }])
    )
  }

  return (
    <>
      <If condition={!hasEmptyCart}>
        <TermsCheckbox />
        <Choose>
          <When condition={isNotLoggedIn}>
            <CheckoutButton
              buttonText={buttonText}
              canSubmit={canContinueCheckout}
              className={BUTTON_CLASSES}
              handleError={handleError}
              url={`${window.location.origin}${routeFor('checkout')}`}
            />
          </When>
          <Otherwise>
            <button
              className={BUTTON_CLASSES}
              data-testid='checkout-button'
              onClick={handleClick}
              role='link'
              type='button'
            >
              {buttonText}
            </button>
          </Otherwise>
        </Choose>
        <If condition={hasBulkPurchaseOrderRequest}>
          <div className='u-push--top'>
            <PurchaseOrderRequestLink />
          </div>
        </If>
      </If>
      <If condition={isDisplayContinueShoppingLink}>
        <div className='u-align--center u-push--top'>
          <a
            className='continue-shopping-link link--branded underline'
            href={routeFor('root')}
          >
            <FormattedMessage id='carts.continue_shopping' />
          </a>
        </div>
      </If>
    </>
  )
}

BeginCheckoutButton.propTypes = {
  isDisplayContinueShoppingLink: PropTypes.bool
}

export default BeginCheckoutButton
